import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";

function GroupCustomer() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [groupList, setGroupList] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
    const [groupPayment, setGroupPayment] = useState([]);
    const [staffQuery, setStaff] = useState([]);

    const [groupname, setGroupname] = useState("");
    const [mobile, setMobile] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedGroupData, setSelectedGroup] = useState(null);
    const [selectedGroupPayment, setSelectedGroupPayment] = useState({});
    const [groupStatus, setGroupStatus] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState("");

    const [selectedMonth, setSelectedMonth] = useState('');

    const rowsPerPage = 30;
    const navigate = useNavigate();

    const [formData, setFormData] = useState({ area_code: "", network: "", date: "", toDate: "" });
    const initialFormData = { area_code: "", network: "", date: "", toDate: "" };
    const totalAmount = (selectedGroupPayment?.pay_amt || 0) * (selectedMonth ? Number(selectedMonth) : 1);

    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) return value;
        }
        return null;
    }

    const user = getCookie('user');

    useEffect(() => {
        if (!user) navigate('/');
    }, [user]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const downloadCSV = () => {
        const headers = ["Sno", "Customer__Name", "Acc_no", "Code", "STB_no", "D_no", "Flat_name", "Street__name", "Phone", "Pay Status", "Plan Amount", "Paid Amount", "Paid_Date", "Balance Amount", "Discount Amount", "Advance Amount", "Pending Amount", "Staff__Code", "Network", "Paid_time", "Package", "Added_date", "Collection Staff"];
        const csvRows = [];
        csvRows.push(headers.join(","));
        allCustomer.forEach((row, index) => {
            const values = [
                index + 1, row.name, row.account_num, row.acc_num, row.serial_num, row.doorno,
                row.flat_name, row.street, row.mobile, row.status, row.pay_amt, row.paid_amt,
                row.paid_date, row.balance, row.discount, row.extra_Balance_amt, row.pend_amt,
                row.area_code, row.net_name, row.paid_time, row.package, row.adate, row.col_boy
            ];
            csvRows.push(values.map(v => `"${v}"`).join(","));
        });

        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!groupname || !mobile) {
            toast.error("Group name and mobile number are required.");
            return;
        }

        setIsButtonDisabled(true);
        try {
            const response = await axios.post('https://node.cabletvpay.in/groupSpecific', { groupname, mobile, user });
            if (response.status === 200) {
                toast.success("Group successfully added.");
                setGroupname("");
                setMobile("");
                fetchUserData();
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error adding group");
        } finally {
            setIsButtonDisabled(false);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await axios.post(`https://node.cabletvpay.in/deleteCustomerGroup`, { user, id });
            if (response.status === 200) {
                toast.success("Customer group deleted successfully.");
                fetchUserData();
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error deleting customer group");
        }
    };

    const handlePayment = (customer_group) => {
        console.log("All Payments:", groupPayment); // ✅ Log all payments
        const groupData = groupList.find(g => g.customer_group === customer_group);
        const paymentData = groupPayment.find(p => p.customer_group === customer_group);

        console.log("Clicked Group:", groupData);
        console.log("Payment Data:", paymentData);

        setSelectedGroup(groupData || {});
        setSelectedGroupPayment(paymentData || {});
    };


   const handleGroupPayment = async () => {
    console.log("handleGroupPayment fired");
    console.log("selectedMonth:", selectedMonth);
    console.log("selectedStaff:", selectedStaff);

    if (!selectedMonth) {
        toast.error("Please select a month before proceeding.");
        return;
    }
    if (!selectedStaff) {
        toast.error("Please select a staff before proceeding.");
        return;
    }

    const paymentData = {
        group_number: selectedGroupData?.group_number,
        customer_group: selectedGroupData?.customer_group,
        pay_amt: selectedGroupPayment?.pay_amt,
        discount: selectedGroupPayment?.discount_amt,
        pend_amt: selectedGroupPayment?.pend_amt,
        total_amount: totalAmount,
        month_count: selectedMonth,
        staff: selectedStaff,
        user: user
    };
    console.log("Payment data being sent:", paymentData);

    try {
        const response = await axios.post('https://node.cabletvpay.in/GrouppaymentUpdate', paymentData);
        if (response.status === 200) {
            toast.success("Payment updated successfully.");
            fetchUserData(); // Refresh data after payment
            setSelectedMonth("");
            window.$('#exampleModal').modal('hide');
        }
    } catch (err) {
        toast.error(err.response?.data?.message || "Error updating payment");
    }
};


    const ViewClick = (customer_group) => {
        navigate(`/groupCustomerView/${customer_group}`, { user });
    };

    const ViewAdd = (customer_group) => {
        navigate(`/groupCustomerAdd/${customer_group}`, { user });
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/groupGetInfo', { user });
            if (response.status === 200) {
                console.log("Group List:", response.data.groupDetails);
                console.log("Group Payments:", response.data.groupPayments); // ✅ Check fields here
                setGroupList(response.data.groupDetails);
                setAllCustomer(response.data.allCustomer);
                setGroupPayment(response.data.groupPayments);
                setStaff(response.data.staffQuery);
                setGroupStatus(response.data.groupStatus);


            }
        } catch (err) {
            setError(err.response?.data?.message || "Error fetching data");
        } finally {
            setLoading(false);
        }
    };
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = groupList.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(groupList.length / rowsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const filteredRows = currentRows.filter((row) =>
        Object.values(row).some(value =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    if (loading) return (
        <div className="content-wrapper">
            <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
                <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" />
            </div>
        </div>
    );

    if (error) return <div className="d-flex justify-content-center align-items-center min-vh-100">Error: {error}</div>;

    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <ToastContainer theme="dark" />
                <div className="fs-4 valuesDec h5 mt-3">GROUP CUSTOMER DETAILS</div>
                <hr />

                <form onSubmit={handleFormSubmit}>
                    <div className="row mx-3 d-flex justify-content-center">
                        <div className="col-lg-3 col-md-6 col-12 mb-2">
                            <label className="text-navy">Enter Group Name</label>
                            <input className="form-control bg-gradient-navy text-white border-0"
                                value={groupname} onChange={(e) => setGroupname(e.target.value)} placeholder="Group Names..." />
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 mb-2">
                            <label className="text-navy">Enter Mobile Number</label>
                            <input className="form-control bg-gradient-navy text-white border-0"
                                value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="Mobile Number..." />
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 mb-2 d-flex justify-content-center pt-lg-4 mt-lg-2 pt-2">
                            <input type="submit" disabled={isButtonDisabled} className="btn bg-gradient-info text-light w-100" value="Add" />
                        </div>
                    </div>
                </form>

                {/* Table Section */}
                <div className="card elevation-5 mt-4" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            <div className="col-lg-6">
                                <input
                                    type="text"
                                    className="form-control bg-light text-navy"
                                    placeholder="Search..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="card-body p-0">
                        <table className="table table-bordered table-responsive-lg">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>S_no</th>
                                    <th>Group Name</th>
                                    <th>Mobile Number</th>
                                    <th>Pay</th>
                                    <th>Customer Details</th>
                                    <th>Customers Count</th>
                                    <th>Add Customers</th>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {filteredRows.length > 0 ? filteredRows.map((row, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{row.customer_group}</td>
                                        <td>{row.group_number}</td>
                                        <td className="text-center">
                                            {(() => {
                                                const statusData = groupStatus.find(gs => gs.group_number === row.group_number);
                                                const hasPending = statusData?.customers_status_count > 0;

                                                return hasPending ? (
                                                    <button
                                                        className="btn btn-info"
                                                        data-toggle="modal"
                                                        data-target="#exampleModal"
                                                        onClick={() => handlePayment(row.customer_group)}
                                                    >
                                                        Pay
                                                    </button>
                                                ) : (
                                                    <p style={{ color: 'red', margin: 0 }}>Paid</p>
                                                );
                                            })()}
                                        </td>

                                        <td className="text-center">
                                            <button className="btn btn-outline-info" onClick={() => ViewClick(row.customer_group)}>
                                                <i className="fas fa-eye" />
                                            </button>
                                        </td>
                                        <td>{row.customerCount}</td>
                                        <td className="text-center">
                                            <button className="btn btn-outline-info" onClick={() => ViewAdd(row.customer_group)}>
                                                <i className="fas fa-user-plus" />
                                            </button>
                                        </td>
                                        <td className="text-center">
                                            <button className="btn text-primary">
                                                <i className="fas fa-edit" />
                                            </button>
                                        </td>
                                        <td className="text-center">
                                            <button className="btn btn-danger" onClick={() => handleDelete(row.id)}>
                                                <i className="fas fa-trash" />
                                            </button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="9" className="text-center">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-end mt-3">
                    <div className="pagination btn-group">
                        <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className="btn btn-secondary">
                            <i className="fas fa-backward"></i>
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                            <button
                                key={page}
                                onClick={() => paginate(page)}
                                className={`btn ${currentPage === page ? "bg-navy text-white" : "btn-outline-secondary"}`}>
                                {page}
                            </button>
                        ))}
                        <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} className="btn btn-secondary">
                            <i className="fas fa-forward"></i>
                        </button>
                    </div>
                </div>

                <div className="modal fade" id="exampleModal" tabIndex={-1} aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header bg-gradient-navy">
                                <h4 className="modal-title text-white">
                                    Payment for {selectedGroupData?.customer_group || "Group"}
                                </h4>
                                <button type="button" className="close" data-dismiss="modal">
                                    <span className="text-white">×</span>
                                </button>
                            </div>

                            <div className="modal-body text-dark">
                                <div className="row">
                                    <div className="col-md-6">
                                        <p><strong>Group Name:</strong> {selectedGroupData?.customer_group}</p>
                                        <p><strong>Package Amount:</strong> ₹{selectedGroupPayment?.pay_amt || 0}</p>
                                        <p><strong>Discount Amount:</strong> ₹{selectedGroupPayment?.discount || 0}</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><strong>Customer Count:</strong> {selectedGroupData?.customerCount || 0}</p>
                                        <p><strong>Mobile:</strong> {selectedGroupData?.group_number || 0}</p>
                                        <p><strong>Pending Amount:</strong> ₹{selectedGroupPayment?.pend_amt || 0}</p>
                                        <p><strong>Pay Amount:</strong> ₹{selectedGroupPayment?.pay_amt || 0}</p>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label><strong>Select Month:</strong></label>
                                    <select
                                        className="form-control"
                                        value={selectedMonth}
                                        onChange={(e) => setSelectedMonth(e.target.value)}
                                    >
                                        <option value="">-- Select Month --</option>
                                        {[...Array(12)].map((_, i) => (
                                            <option key={i} value={i + 1}>{i + 1} Month</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label><strong>Select a Staff:</strong></label>
                                    <select
                                        className='form-control bg-light'
                                        value={selectedStaff}
                                        onChange={(e) => setSelectedStaff(e.target.value)}
                                    >
                                        <option value="">Select a staff</option>
                                        {Array.isArray(staffQuery) && staffQuery.length > 0 ? (
                                            staffQuery.map((row, index) => (
                                                <option key={index} value={`${row.name}-${row.staffCode}-${row.mobile}`}>
                                                    {row.name} - ({row.staffCode})
                                                </option>
                                            ))
                                        ) : (
                                            <option value="">No staff available</option>
                                        )}
                                    </select>

                                </div>
                                {/* ✅ Dynamically Updated Total */}
                                <p><strong>Total Amount:</strong> ₹{totalAmount}</p>
                                <div className="text-center"> <button type="button" className="btn btn-info" onClick={handleGroupPayment}>Pay</button> </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default GroupCustomer;
